// extracted by mini-css-extract-plugin
module.exports = {"table":"ItemsListContainer_table__2YoXM"};